import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { ReadyReaders } from '../layout/ReadyReaders.js';
import { RegularLineItem } from '../layout/RegularLineItem.js';
import { SolutionSpecsContainer } from './SolutionSpecsContainer.js';
import { ContactLensSpecsContainer } from './ContactLensSpecsContainer.js';
import { ContactLensesSubscription } from '../layout/ContactLensesSubscription.js';
import { ContactLensesBundleBenelux } from '../layout/ContactLensesBundleBenelux.js';
import { NonPrescriptionBundleLineItem } from '../layout/NonPrescriptionBundleLineItem.js';
import { PrescriptionGlassesLineItem } from '../layout/PrescriptionGlassesLineItem.js';
import { useCartSettings } from '../../../context/CartSettings/context.js';
import { useCartSlots } from '../../../slots/context.js';

const LineItemsContainer = ({ lineItems  })=>{
    const settings = useCartSettings();
    const { getLabel  } = useIntl();
    const { Slots  } = useCartSlots();
    const [isLineItemClickable, setIsLineItemClickable] = React.useState(true);
    React.useEffect(()=>{
        if (typeof window !== 'undefined') {
            const { pathname  } = window.location;
            /**
       *  Make the lineItem images NON clickable, if the user is in the checkout flow
       *  This will prevent user from leaving checkout funnel
       */ if (pathname.includes('/checkout') || pathname.includes('/express-checkout')) setIsLineItemClickable(false);
        }
    }, []);
    const labels = React.useMemo(()=>({
            quantity: getLabel('cart.item.quantity'),
            iconLeftEye: getLabel('products.contactLenses.leftEye'),
            iconRightEye: getLabel('products.contactLenses.rightEye'),
            power: getLabel('products.contactLenses.prescription.power'),
            monthlySubscription: getLabel('products.monthlySubscription'),
            deliveredEvery: getLabel('cart.delivery.frequency'),
            perBox: getLabel('products.perBox')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, lineItems.map((lineItem)=>{
        const sharedProps = {
            isLineItemClickable,
            key: lineItem.id,
            settings,
            labels
        };
        switch(lineItem.type){
            case 'prescription-glasses':
                return /*#__PURE__*/ React.createElement(PrescriptionGlassesLineItem, swcHelpers.extends({}, sharedProps, {
                    lineItem: lineItem
                }));
            case 'non-prescription-bundle':
                return /*#__PURE__*/ React.createElement(NonPrescriptionBundleLineItem, swcHelpers.extends({}, sharedProps, {
                    lineItem: lineItem
                }));
            case 'contact-lenses-bundle-benelux':
                return /*#__PURE__*/ React.createElement(ContactLensesBundleBenelux, swcHelpers.extends({}, sharedProps, {
                    lineItem: lineItem
                }));
            case 'contact-lenses-subscription':
                return /*#__PURE__*/ React.createElement(ContactLensesSubscription, swcHelpers.extends({}, sharedProps, {
                    lineItem: lineItem
                }));
            case 'contact-lenses':
                const { colorLens , eyeSide , packageQuantity , replacementFrequency , specs  } = lineItem;
                return /*#__PURE__*/ React.createElement(RegularLineItem, swcHelpers.extends({}, sharedProps, {
                    lineItem: lineItem,
                    lineItemMediaIcon: {
                        iconName: `${eyeSide}-eye`,
                        iconLabel: eyeSide === 'left' ? labels.iconLeftEye : labels.iconRightEye
                    },
                    specsChild: /*#__PURE__*/ React.createElement(ContactLensSpecsContainer, {
                        colorLens: colorLens,
                        packageQuantity: packageQuantity,
                        replacementFrequency: replacementFrequency,
                        specs: specs
                    }),
                    quotationChild: Slots.Quotation ? /*#__PURE__*/ React.createElement(Slots.Quotation, {
                        type: "CONTACT_LENSES"
                    }) : null
                }));
            case 'solutions':
                return /*#__PURE__*/ React.createElement(RegularLineItem, swcHelpers.extends({}, sharedProps, {
                    lineItem: lineItem,
                    specsChild: /*#__PURE__*/ React.createElement(SolutionSpecsContainer, {
                        type: lineItem.solutionType,
                        volume: lineItem.solutionVolume
                    })
                }));
            case 'ready-readers':
                return /*#__PURE__*/ React.createElement(ReadyReaders, {
                    key: lineItem.id,
                    lineItem: lineItem,
                    settings: settings,
                    labels: labels,
                    isLineItemClickable: isLineItemClickable
                });
            // 'sunglasses', accessories and 'frames' will default here
            default:
                return /*#__PURE__*/ React.createElement(RegularLineItem, swcHelpers.extends({}, sharedProps, {
                    lineItem: lineItem
                }));
        }
    }));
};

export { LineItemsContainer };
//# sourceMappingURL=LineItemsContainer.js.map
